import script from "./HeaderMessagesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMessagesModal.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMessagesModal.vue?vue&type=style&index=0&id=060a634c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060a634c"]])

export default __exports__